var render = function render(){var _vm=this,_c=_vm._self._c;return _c('datepicker',{staticClass:"form_fix",attrs:{"format":"MM/yyyy","minimumView":'month',"maximumView":'month',"language":_vm.vi,"placeholder":_vm.placeholder,"clearButton":true},model:{value:(_vm.month),callback:function ($$v) {_vm.month=$$v},expression:"month"}})
}
var staticRenderFns = []

export { render, staticRenderFns }